import { render, staticRenderFns } from "./MediaSelect.vue?vue&type=template&id=95b460f6&"
import script from "./MediaSelect.vue?vue&type=script&lang=js&"
export * from "./MediaSelect.vue?vue&type=script&lang=js&"
import style0 from "./MediaSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports